import { useUserGroups } from '@src/providers';
import type { UserGroup } from '@src/types';
import { logger } from '@talos/kyoko';
import { useEffect, useState } from 'react';

export const useUserGroupsList = (): UserGroup[] | undefined => {
  const { listUserGroups } = useUserGroups();
  const [userGroups, setUserGroups] = useState<UserGroup[]>();

  useEffect(() => {
    let isMounted = true;
    listUserGroups()
      .then(response => {
        if (isMounted) {
          setUserGroups(response.data || []);
        }
      })
      .catch(e => {
        logger.error(e);
        if (isMounted) {
          setUserGroups([]);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [listUserGroups]);

  return userGroups;
};
